module.exports = __webpack_public_path__ + "img/icon-search-black.63ffc13a.svg";